import { Box, Divider, Grid, Skeleton, Toolbar } from "@mui/material";

export default function HeaderExternalSkeleton() {
  const verticalDivider = () => <Divider orientation='vertical' flexItem sx={{ height: 24, alignSelf: 'center', mx: 0.5 }} />

  return (
    <Grid item xs={12} width="100%">
      <Toolbar sx={{ px: 0, height: 82, minHeight: 82 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          px: { xs: 2, md: '20vw' },
          flexWrap: 'nowrap',
          gap: 1,
          py: 2,
        }}>
          {/* Logo + título skeleton */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 1, minWidth: 0 }}>
            <Skeleton
              variant="rectangular"
              width={140}
              height={44}
              sx={{ borderRadius: 1 }}
            />
            {verticalDivider()}
            <Skeleton variant="text" width={120} height={32} />
          </Box>

          {/* Nav links + botão skeleton */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 }, flexWrap: 'nowrap' }}>
            <Skeleton variant="text" width={60} height={28} />
            {verticalDivider()}
            <Skeleton variant="text" width={180} height={28} sx={{ display: { xs: 'none', sm: 'block' } }} />
            {verticalDivider()}
            <Skeleton variant="text" width={40} height={28} sx={{ display: { xs: 'none', sm: 'block' } }} />
            {verticalDivider()}
            <Skeleton
              variant="rounded"
              width={160}
              height={36}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Box>
      </Toolbar>
    </Grid>
  )
}